import axiosInstance from './axios';

const AccountAPI = {

    getTransactions : () => {
        return axiosInstance.get('transactions', { });
    },
    getBalance : () => {
        return axiosInstance.get('transactions/balance', { });
    },
    getCreditPackages : () => {
        return axiosInstance.get('transactions/packages', { });
    },
    topUp : (amount) => {
        return axiosInstance.post('transactions/top-up', { amount });
    },


}

export default AccountAPI;